import React from 'react';
import {NavLink} from 'react-router-dom';
import classNames from 'classnames';

import {BiCodeAlt, BiLogOut} from 'react-icons/bi';
import {DiJqueryLogo} from 'react-icons/di';
import {IoMdHome} from 'react-icons/io';
import {pageRoutes} from '../routes';
import {BsBag, BsPen} from 'react-icons/bs';
import {FiUsers} from 'react-icons/fi';
import {GiSkills} from 'react-icons/gi';
import {MdAssessment} from 'react-icons/md';

import useAuthStore from '../store/useAuthStore';
import {AiOutlineFileSearch} from 'react-icons/ai';

export const sideMenuList = [
  // {
  //   path: pageRoutes.dashboard,
  //   title: 'Dashboard',
  //   logo: <IoMdHome size="20" />,
  // },
  // {
  //   path: pageRoutes.manageCandidate,
  //   title: 'Candidate Management',
  //   logo: <FiUsers size="20" />,
  // },
  {
    path: pageRoutes.manageUser,
    title: 'User Management',
    logo: <FiUsers size="20" />,
  },
  // {
  //   path: pageRoutes.skills,
  //   title: 'Skill',
  //   logo: <GiSkills size="23" />,
  // },
  {
    path: pageRoutes.subjects,
    title: 'Test Management',
    logo: <BsPen size="20" />,
  },
  {
    path: pageRoutes.codingChallenge,
    title: 'Coding Challenge',
    logo: <BiCodeAlt size="25" />,
  },
  {
    path: pageRoutes.assessments,
    title: 'Assessments',
    logo: <MdAssessment size="20" />,
  },
];

const Sidebar = ({isMenuOpen, setIsMenuOpen}) => {
  const updateAuthDetails = useAuthStore((state) => state.updateAuthDetails);
  const user = useAuthStore((state) => state.user);

  const handleLogout = () => {
    updateAuthDetails({});
    localStorage.removeItem('auth');
  };

  const navItemClassNames = ({isActive}) => {
    return classNames(
      'h-full py-6 flex items-center border-r-[3.5px] hover:text-primary-main hover:bg-primary-light font-normal',
      !isActive
        ? 'font-medium border-white hover:border-primary-light'
        : 'bg-primary-light border-primary-main text-primary-main font-semibold',
      isMenuOpen ? 'gap-3.5 pl-6 justify-start' : 'justify-center',
    );
  };

  // Filter menu items based on role
  let filteredMenu = sideMenuList;
  if (user?.role === 'invigilator') {
    filteredMenu = sideMenuList.filter(
      (item) => item.path === pageRoutes.assessments,
    );
  }

  return (
    <div
      className={classNames(
        'sticky top-0 left-0 flex flex-col justify-between h-screen shadow-[5px_0_25px_#0000001A] z-[10] bg-white',
        isMenuOpen ? 'w-[250px] min-w-[250px]' : 'w-[80px]',
      )}
    >
      <button
        className={classNames(
          'absolute top-[75px] right-3 text-primary-main text-sm z-100 w-7 h-7',
          !isMenuOpen ? 'inset-0 right-[5px] mx-auto rotate-180' : '',
        )}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <img src="/assets/navbar/control.png" alt="toggle menu" />
      </button>

      <div className="flex flex-col justify-between ">
        <div className="flex-center py-3 h-[88px] bg-white text-secondary-light shadow-[0_0_15px_#0000001A]">
          {/* <DiJqueryLogo size="20" className="w-12 h-12" /> */}
          <img src="/tiwra.webp" alt="logo" className="w-16 h-18 " />
        </div>

        <ul className="d-block list-none">
          {filteredMenu.map(({path, title, logo}) => (
            <li key={path}>
              <NavLink to={path} className={navItemClassNames} end>
                {logo}
                {isMenuOpen && title}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

      <button
        onClick={handleLogout}
        className="mb-5 p-3 flex-center gap-2 font-bold hover:bg-primary-light hover:text-primary-main"
      >
        <BiLogOut size={30} /> {isMenuOpen && 'Logout'}
      </button>
    </div>
  );
};

export default Sidebar;
